import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-small" }
const _hoisted_2 = { class: "s14_mobile" }
const _hoisted_3 = { class: "card px-3 py-3" }
const _hoisted_4 = {
  key: 0,
  class: "widget-media flex-center px-7 py-5 barMedia-anim cursor-pointer"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "s20 mb-4",
  id: "video_container"
}
const _hoisted_7 = ["poster"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "font-semibold text-black mt-3 mb-4 px-5 pb-2" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "s5_mobile" }
const _hoisted_12 = { class: "grid1" }
const _hoisted_13 = { class: "card px-2 py-2" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "font-semibold text-black mt-3 mb-4 px-4" }

import { API_CONFIG, BACKEND_URL } from '@/services/apiConfig';
import { nextTick, onMounted, reactive, ref, toRaw, watch } from 'vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'TutorialsDetailsView',
  setup(__props) {

const route = useRoute();
const loading = ref(false);
const errorMessage = ref('');
const item = reactive({
    id: 0,
    slug: '',
    libelle: '',
    contenu_aide: '',
    created_at: '',
    fichier_photo: '',
    fichier_video: '',
    etat_valide: 0,
    type_aide: '',
    categorie_aide_id: 0,
    categorie_aide: {
        id: 0,
        libelle: ''
    }
});
const relatedItems = ref([] as any[]);
const videoPlayer = ref(null as any);
const previousRoute = ref('');
const isPlaying = ref(false);

onMounted(() => {
    const data: any = route.meta.startup_infos;
    Object.assign(item, data.tutoriel);
    relatedItems.value = data.related_tutoriels;
    previousRoute.value = route.meta.prevRoute as string;
});

watch(() => route.params.slug, (newSlug) => {
    fetchItem(newSlug)
});

async function fetchItem(slug: any) {
    try {
        loading.value = true;
        errorMessage.value = '';
        const response = await fetch(`${API_CONFIG.baseURL}/tutoriels/${slug}`, {
            method: 'GET',
            headers: API_CONFIG.headers
        });
        const data = await response.json();
        Object.assign(item, data.tutoriel);
        relatedItems.value = data.related_tutoriels;
    } catch (error: any) {
        errorMessage.value = error;
    } finally {
        loading.value = false;
    }
}

function playVideo() {
    console.log(item);
    if (!item.fichier_video) { return; }
    isPlaying.value = true;
    nextTick(() => {
        if (videoPlayer.value) {
            videoPlayer.value.play();
        }
    })
}

function stopVideo() {
    if (videoPlayer.value) {
        videoPlayer.value.pause();
    }
    isPlaying.value = false;
}


function formatDate(dateString: string, format = 'DD/MM/YYYY HH:mm') {
    if (!dateString) return "";

    const date = new Date(dateString);

    const map = {
        DD: String(date.getDate()).padStart(2, '0'),
        MM: String(date.getMonth() + 1).padStart(2, '0'),
        YYYY: date.getFullYear(),
        HH: String(date.getHours()).padStart(2, '0'),
        mm: String(date.getMinutes()).padStart(2, '0'),
        ss: String(date.getSeconds()).padStart(2, '0'),
    };

    let formatted = format;
    for (const [key, value] of Object.entries(map)) {
        formatted = formatted.replace(key, value as any);
    }

    return formatted;
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "page-space" }, null, -1)),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (!isPlaying.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "widget-img",
                id: "video_layer",
                onClick: playVideo
              }, [
                (item.fichier_video)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("img", {
                        src: "/public/icons/icon-play.svg",
                        class: "size-2xl"
                      }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true),
                _createElementVNode("img", {
                  src: _unref(BACKEND_URL) + '/assets/aide/1000/' + item.fichier_photo,
                  width: "100%"
                }, null, 8, _hoisted_5)
              ]))
            : _createCommentVNode("", true),
          (isPlaying.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("video", {
                  id: "video_player",
                  class: "video-size",
                  poster: _unref(BACKEND_URL) + '/assets/aide/1000/' + item.fichier_photo,
                  autoplay: "",
                  controls: ""
                }, [
                  _createElementVNode("source", {
                    src: _unref(BACKEND_URL) + '/assets/aide/' + item.fichier_video
                  }, null, 8, _hoisted_8)
                ], 8, _hoisted_7)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("h1", _hoisted_9, _toDisplayString(item.libelle), 1)
        ]),
        _createElementVNode("p", {
          class: "text-read px-5 mt-7",
          innerHTML: item.contenu_aide
        }, null, 8, _hoisted_10)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "s1_mobile" }, " ", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "clear-both h-20 show-mobile" }, null, -1)),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relatedItems.value, (rItem) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: 'related_item_' + rItem.id,
              to: '/tutoriels/' + rItem.slug
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  (rItem.fichier_photo)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(BACKEND_URL) + '/assets/aide/1000/' + rItem.fichier_photo,
                        width: "100%",
                        class: "mb-5",
                        alt: ""
                      }, null, 8, _hoisted_14))
                    : _createCommentVNode("", true),
                  _createElementVNode("h5", _hoisted_15, _toDisplayString(rItem.libelle), 1)
                ])
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ])
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "clear-both h-70" }, null, -1))
    ])
  ], 64))
}
}

})